import * as angular from "angular";
import {Institution} from "../../models/institution.model";
import {ApiUrl} from "../../models/app-config.model";

interface InstitutionResponse { data: Institution; }

export interface InstitutionService { (tenantId): angular.IPromise<Institution>; }

/* @ngInject */
export function institutionService(API_URL: ApiUrl, $http: angular.IHttpService): InstitutionService {
    return (tenantId: string) => {
        return $http.get(`${API_URL.institution}/${tenantId}?query={"product":15}`)
            .then((response: InstitutionResponse) => response.data);
    };
}


/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./app/common/institution/institution-service.ts
 **/